export const MONTHS =
    [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
    ];



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/timer/months.ts